import { render } from "./criteria-list.vue?vue&type=template&id=1c90afc8"
import script from "./criteria-list.vue?vue&type=script&lang=js"
export * from "./criteria-list.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__